let audioContext: AudioContext | null = null;

export async function getAudioContext(): Promise<AudioContext> {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  if (audioContext.state === 'suspended') await audioContext.resume();
  return audioContext;
}

function envelopeGain(ctx: AudioContext, start: number, duration: number, peak = 0.18): GainNode {
  const gain = ctx.createGain();
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(peak, start + 0.025);
  gain.gain.setValueAtTime(peak, start + duration - 0.035);
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);
  return gain;
}

export async function playTonePair(baseHz: number, deltaCents: number, higher: 'first' | 'second'): Promise<void> {
  const ctx = await getAudioContext();
  const now = ctx.currentTime + 0.05;
  const duration = 0.34;
  const gap = 0.22;
  const highHz = baseHz * Math.pow(2, deltaCents / 1200);
  const firstHz = higher === 'first' ? highHz : baseHz;
  const secondHz = higher === 'second' ? highHz : baseHz;

  const makeTone = (frequency: number, start: number) => {
    const osc = ctx.createOscillator();
    const gain = envelopeGain(ctx, start, duration);
    const filter = ctx.createBiquadFilter();
    filter.type = 'lowpass';
    filter.frequency.value = Math.min(4800, frequency * 5);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(frequency, start);
    osc.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);
    osc.start(start);
    osc.stop(start + duration + 0.02);
  };

  makeTone(firstHz, now);
  makeTone(secondHz, now + duration + gap);

  await new Promise((resolve) => window.setTimeout(resolve, (duration * 2 + gap + 0.12) * 1000));
}

export function centsToRatio(cents: number): number {
  return Math.pow(2, cents / 1200);
}
